import { ServiceLocator } from './../ServiceLocator';
import { Component, Input, AfterContentInit, Optional } from '@angular/core';
import { from, empty, of, Subject } from 'rxjs';
import { PlycaDataService } from '../../services/plyca.service';
import { PaginationDTO } from '../api/PaginationModel';
import { UserPrefs } from '../api/UserPrefs-dto';
import { Store } from '@ngrx/store';
import { AppState } from '../store/AppState';
import { UserService } from '../user.service';
import { Configuration } from '../conf/app.constants';
import { ProjectEntityDTO } from '../api/plyca-dtos-v2';
import { ConfirmationService } from 'primeng-lts/api';
import { TranslateService } from '@ngx-translate/core';
import { finalize, map, catchError, concatMap } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
import { documentViewerComponent } from '../documents/documentViewer/documentViewer.component';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { UserPrefsService } from '../store/user-prefs.service';
import { BaseWidget } from './baseWidget';

@Component({
  selector: 'favourites',
  templateUrl: 'favourites.template.html',
  providers: [DialogService]
})
export class favouritesComponent extends BaseWidget implements AfterContentInit {
  userPrefs: UserPrefs;

  // columnas adicionales al expediente para visualizar informacion adicional cuando el widget es de tipo atributo
  columns: string[];
  columnsByOrder: string[];
  existColumnsConf = false;
  columnsTH: string[];

  dossiers: any[] = [];

  loaded = false;
  error = false;
  showDeleteButton = false;
  isDialog = false;
  pageFirst: number = 0;
  
  private dialogService: DialogService;


  constructor(
    public plycaService: PlycaDataService,
    private store: Store<AppState>,
    private confirmationService: ConfirmationService,
    protected router: Router,
    public translationService: TranslateService,
    public configuration: Configuration,
    private userService: UserService,

    public ref: DynamicDialogRef,
    private userPrefsService: UserPrefsService,
    @Optional() dialogConfig: DynamicDialogConfig
  ) {
    super();
    this.dialogService = ServiceLocator.injector.get(DialogService);

    if (dialogConfig && dialogConfig.data) {
      this.type = dialogConfig.data.type;
      this.attributeId = dialogConfig.data.attributeId;
      this.attributeParams = dialogConfig.data.attributeParams;
      this.titleKey = dialogConfig.data.titleKey;
      this.title = dialogConfig.data.title;
      this.descriptionKey = dialogConfig.data.descriptionKey;
      this.description = dialogConfig.data.description;
      this.isDialog = true;
      this.subscribe(router.events, e => {
        if (e instanceof NavigationEnd) {
          this.ref.close();
        }
      });
      // establecemos la paginacion por defecto si no viene
      if(!this.pageSize || this.pageSize==0)
        this.pageSize=10;
      // eliminar referencias de memoria a datos pasados desde el padre
      dialogConfig = null;
    }

    this.subscribe(this.userPrefsService.getUserPrefs()
      , (prefs: UserPrefs) => {
        this.userPrefs = prefs;
      });
  }

  // ngAfterContentInit(): void {
  //   // this.subscribe(this.reloadSubject, (filters) => this.reload(filters));
  //   super.ngAfterContentInit();

  //   console.log(this.columnsFormat);
  //   this.reloadWidget();
  // }

  ngOnDestroy() {
    this.dialogService = null;
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  reloadWidget(filterStr?: string): void {
    this.loaded = false;
    this.dossiers = [];
    if (this.type === 'favourites') {
      this.showDeleteButton = true;
      this.subscribe(this.plycaService
        .getFavouriteDossiers(this.userService.getUserId())
        .pipe(
          finalize(() => {
            this.loaded = true;
          })
        ),
        (param: PaginationDTO<any>) => {
          if (param && param.content) {
            this.dossiers = param.content;
          } else {
            this.dossiers = [];
          }
        },
        err => {
          console.log(err);
        }
      );
    } else if (this.type == 'lastAccessed') {
      this.subscribe(this.plycaService
        .getLastAccessedDossiers(this.userService.getUserId())
        .pipe(
          finalize(() => {
            this.loaded = true;
          })
        ),
        (param: PaginationDTO<any>) => {
          if (param && param.content) {
            this.dossiers = param.content;
          } else {
            this.dossiers = [];
          }
        });
    } else if (this.type === 'attribute' || this.type === 'attribute-count') {
      if (this.attributeId) {
        let colss = undefined;
        // this.columns = undefined;
        this.subscribe(this.plycaService.getAttribute(this.attributeId).pipe(finalize(() => {
          console.log('finalize attrib');
        })),
          attrib => {
            console.log(attrib);
            // Se calculan las columnas  que devuelve el atributo con el primer elemento devuelto
            this.columns = [];
            this.columnsTH = [];
            colss = [];
            attrib.resultDefinition.columns.forEach(_col => {
              //colss.push(_col.name.replace(/\s/g, ""));
              colss.push(_col.name);
              this.columnsTH.push(_col.description);

            });
            // this.columns = colss;
            if (attrib.resultDefinition.columns[0].order) {
              attrib.resultDefinition.columns.forEach(_col => {
                //colss[_col.order - 1] = _col.name.replace(/\s/g, "");
                colss[_col.order - 1] = _col.name;
                this.columnsTH[_col.order - 1] = _col.description;
              });
              // this.columns = colss;
            }
            this.columns = colss;
            this.subscribe(this.plycaService.getAttributeValue(this.attributeId, filterStr)
              .pipe(
                concatMap(x => {
                  let data = [];
                  if (x.values) {

                    if (this.columnsFormat && this.columnsFormat[this.columns[0]].columnOrder && x.values.length > 0) {
                      this.existColumnsConf = true;
                      // Ordenacion de las columnas con configuracion de cliente
                      // Si hay sobreescribe la se servidor
                      if (this.columnsFormat[this.columns[0]].columnOrder) {
                        this.columnsByOrder = this.columns;
                        Object.keys(this.columnsFormat).forEach(_col => {
                          this.columnsByOrder[this.columnsFormat[_col].columnOrder - 1] = _col;
                        });
                        this.columns = this.columnsByOrder;
                      }
                    }
                    // recorremos el array y creamos un objeto con la propuestaId y los valores de cada columna
                    x.values.forEach(val => {
                      let dossier = {};
                      try {



                        this.columns.forEach(_col => {
                          let value = '';
                          try {
                            value = val['columns'][_col]['value'];
                          } catch { }
                          dossier[_col] = value;
                        });
                        dossier['PROPUESTAID'] = val['columns']['PROPUESTAID'][
                          'value'
                        ].replace('/', '');

                        data.push(dossier);
                      } catch (e) { }
                    });
                  }
                  return from(data);
                }),
                concatMap(data => {
                  if (this.type === 'attribute-count')
                    return of(data);
                  else if (data['JSON_PROJECT']) {
                    data['project'] = JSON.parse(data['JSON_PROJECT']);
                    delete data['JSON_PROJECT'];
                    return of(data);
                  } else
                    // con cada objeto se lee el project y se incorpora al objeto
                    return this.plycaService
                      .get(
                        this.configuration.PROJECTENTITY_SERVICE_URL,
                        data['PROPUESTAID'],
                        {
                          expand: 'expansionSet:MINIMAL'
                        }
                      )
                      .pipe(
                        catchError(err => empty()),
                        map((param: ProjectEntityDTO) => {
                          data['project'] = param;
                          return data;
                        })
                      );
                })
                , finalize(() => {
                  this.loaded = true;
                })),
              (data: Array<any>) => {
                // Se ejcuta para cada línea de datos
                this.dossiers.push(data);
              }
              ,
              (err) => {
                console.log(err);
                this.error = true;
              }
            );
          }
          ,
          (err) => {
            console.log(err);
            this.error = true;
            this.loaded = true;
          }
        )
      } else {
        this.error = true;
        this.loaded = true;
      }
    }
  }

  delete(id: any) {
    let url = '';

    if (this.type === 'favourites') {
      url = this.configuration.FAVOURITE_SERVICE_URL;
    }

    this.confirmationService.confirm({
      message: this.translationService.instant('General.confirm.action.delete'),
      accept: () => {
        this.loaded = false;
        this.subscribe(this.plycaService
          .delete(url, id)
          .pipe(
            finalize(() => {
              this.reloadWidget();
              this.loaded = true;
            })
          ),
          (result: any) => {
            console.log(result);
          });
      }
    });
  }

  typeClass(): string {
    if (this.type === 'lastAccessed') {
      return 'fa-list-ul text-emphasis';
    } else if (this.type === 'favourites') {
      return 'fa-star text-warning';
    }
  }

  openDossier(dossier) {
    this.router.navigate(['/dossierInfo/' + dossier.identifier]);
  }

  public openModalWidget() {
    let config: DynamicDialogConfig = {
      header: this.title,
      width: '80%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'searchStyle'
    };
    config.data = {
      attributeId: this.attributeId,
      type: (this.type == 'attribute-count' ? 'attribute' : this.type),
      titleKey: this.titleKey,
      title: this.title,
      descriptionKey: this.descriptionKey,
      description: this.description
    }
    this.dialogService.open(favouritesComponent, config);
  }

  widgetClass(): string {
    if (this.dossiers.length === 0)
      return 'alert-secondary text-secondary';
    else
      return this.estilos;
  }

  public showDocument(uuid: any): void {
    let config: DynamicDialogConfig = {
      header: '',
      width: '75%',
      styleClass: 'searchStyle'
    };

    config.data = {
      'id': uuid
    }

    let modal = this.dialogService.open(documentViewerComponent, config);
    this.subscribe(modal.onClose);
  }

  public getColumnName(column, index) {
    let text = '';
    // console.log(column);

    if (column == 'JSON_PROJECT')
      return text;

    if (!this.existColumnsConf) {
      text = this.columnsTH[index];
    } else if (!this.columnsFormat[column]
      || !this.columnsFormat[column].columnType
      || this.columnsFormat[column].columnType != 'action') {
      // console.log(column);
      text = this.columnsFormat[column].descriptionKey ? this.translationService.instant(this.columnsFormat[column].descriptionKey) : this.columnsFormat[column].description ? this.columnsFormat
      [column].description : column;
      //console.log(text);
    }
    //console.log(text);
    return text;

  }

  paginate(event) {
    this.pageFirst = event.first;
  }
}
